import React, { Component } from 'react'
import { Container, Menu, Button, Dropdown } from 'semantic-ui-react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, Routes } from 'react-router-dom'
import { logout, managerContext } from '../../services/User';
import { setAuthState, setSearchFormVisibilityInHeader, setPageType, setShowSidebar } from '../../store/actions/actions';
import hamburger_icon from '../../assets/images/newui/hamburger-icon.svg'
import moment from 'moment';
import '../../assets/css/common.less'
import './MasterContainer.less'
import PrivateRoute from 'components/PrivateRoute/PrivateRoute';
import SignInContainerNew from 'containers/SignInContainer/SignInContainerNew';
import ServiceRequestListContainerNew from 'containers/ServiceRequestListContainerNew/ServiceRequestListContainerNew';
import { NavigationUrls } from 'constants/NavigationUrls';
import UpdateSellerContainer from 'containers/UpdateSellerContainer/UpdateSellerContainer';
import SellerReviewContainer from 'containers/SellerReviewContainer/SellerReviewContainer';
import TrialSubscriptions from 'containers/TrialSubscriptions/TrialSubscriptions';
import FailedSubscriptionsContainer from 'containers/FailedSubscriptions/FailedSubscriptionsContainer';
import AddSubscription from 'containers/AddSubscription/AddSubscription';
import FailedCommissionPayments from 'containers/FailedCommissionPayments/FailedCommissionPayments'
import AccountsDashboardContainer from 'containers/AccountsDashboardContainer/AccountsDashboardContainer'
import SBRAssignmentDashboardContainer from 'containers/SBRAssignmentDashboardContainer/SBRAssignmentDashboardContainer';
import AMDashboardContainer from 'containers/AMDashboardContainer/AMDashboardContainer';
import UsersFillRateDashboardContainer from 'containers/UsersFillRateDashboardContainer/UsersFillRateDashboardContainer';
import UsersWeeklyFillRateContainer from 'containers/UsersWeeklyFillRateContainer/UsersWeeklyFillRateContainer';
import MessengerContainer from 'containers/MessengerContainer/MessengerContainer';
import SubscriptionSearchContainer from 'containers/SubscriptionSearchContainer/SubscriptionSearchContainer';
import ChurnCandidatesContainer from 'containers/ChurnCandidatesContainer/ChurnCandidatesContainer';
import CommissionPayments from '../CommissionPayments/CommissionPayments';
import featuresList from '../../constants/FeaturesList';
import { checkManagerAuthorization } from 'helpers/authorization';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import AddCommissionOnlySubscription from 'containers/AddSubscription/AddCommissionOnlySubscription';
import SellerPlans from 'containers/SellerPlans/SellerPlans';
import ImpersonateUsers from 'containers/ImpersonateUsers/ImpersonateUsers';
import RadiusCheckContainer from 'containers/RadiusCheckContainer/RadiusCheckContainer';
import ActualCommissionRevenue from 'containers/ActualCommissionRevenueContainer/ActualCommissionRevenueContainer';
import SetSellerPasswordContainer from 'containers/SetSellerPasswordContainer/SetSellerPasswordContainer';
import SellerListByAcceptingJob from 'containers/SellerListByAcceptingJob/SellerListByAcceptingJob'
import SellerCategoryRadiusContainer from 'containers/SellerCategoryRadiusContainer/SellerCategoryRadiusContainer';
import SaasMetricsContainer from 'containers/SaasMetricsContainer/SaasMetricsContainer';

const initialState = {
    lat: 0,
    lon: 0,
    locationSet: false,
    results: [],
    searchValue: '',
    isLoading: false,
    selectedServiceId: 0,
    selectedServiceName: '',
    serviceSEOName: '',
    showZipModalLoader: false,
    windowWidth: window.innerWidth,
    sidebarVisible: false,
    loadPage: false,
};

class MasterContainer extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
        this.hiwRef = React.createRef();
        this.pageTopRef = React.createRef();
    }

    async componentDidUpdate(prevProps) {
        const { loggedIn, currentUser } = this.props;
        if (loggedIn && this.props.loggedIn != prevProps.loggedIn) {
        }
    }

    async componentDidMount() {
        try {
            this.updateWindowDimensions();
            window.addEventListener('resize', this.updateWindowDimensions);
            const { loggedIn, currentUser } = this.props;
            if (!loggedIn || _.isEmpty(currentUser)) {
                const response = await managerContext();
                if (response && response.data) {
                    this.props.setAuthState(true, response.data.user, '');
                }
            }
        }
        catch (e) {
            console.log("error: ",e);
        }
        this.setState({ loadPage: true });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });

    }

    handleHamburgerIcon = () => {
        this.props.setShowSidebar(!this.props.showSidebar);
        setTimeout(() => {
            //this.props.setShowSidebar(false);
        }, 5000);

    }

    onBackToTopClick = () => {
        this.pageTopRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }

    render() {

        const { activeMenuItem, currentUser } = this.props;
        return (this.state.loadPage &&
            <>

                <Container fluid className={"master-container"}>
                    <div id="page" >
                        {(this.props.history.location.pathname.startsWith('/request/old') ||
                            this.props.history.location.pathname.startsWith('/seller-profile') || 
                            this.props.history.location.pathname.startsWith('/seller-reviews') ||
                            this.props.history.location.pathname.startsWith('/trial-subscription') || 
                            this.props.history.location.pathname.startsWith('/subscription') ||
                            this.props.history.location.pathname.startsWith('/failed-commission-payments') || 
                            this.props.history.location.pathname.startsWith('/accounts-dashboard') ||
                            this.props.history.location.pathname.startsWith('/failed-subscription-payments') ||
                            this.props.history.location.pathname.startsWith(`${NavigationUrls.REQUEST_DASHBOARD}`) ||
                            this.props.history.location.pathname.startsWith('/messenger') ||
                            this.props.history.location.pathname.startsWith('/users-fill-rate') ||
                            this.props.history.location.pathname.startsWith(NavigationUrls.ADD_SUBSCRIPTION) ||
                            this.props.history.location.pathname.startsWith(NavigationUrls.ADD_COMMISSION_ONLY_SUBSCRIPTION) ||
                            this.props.history.location.pathname.startsWith(NavigationUrls.SUBSCRIPTION_SEARCH) ||
                            this.props.history.location.pathname.startsWith(NavigationUrls.CHURN_CANDIDATES) ||
                            this.props.history.location.pathname.startsWith(NavigationUrls.USERS_WEEKLY_FILLRATE) ||
                            this.props.history.location.pathname.startsWith(NavigationUrls.AM_DASHBOARD) || 
                            this.props.history.location.pathname.startsWith(NavigationUrls.COMMISSION_PAYMENTS) || 
                            this.props.history.location.pathname.startsWith(NavigationUrls.PAYMENT_PLANS) ||
                            this.props.history.location.pathname.startsWith(NavigationUrls.IMPERSONATE_USER) || 
                            this.props.history.location.pathname.startsWith(NavigationUrls.RADIUS_CHECK)) ||
                            this.props.history.location.pathname.startsWith(NavigationUrls.ACTUAL_COMMISSION_REVENUE) ||
                            this.props.history.location.pathname.startsWith(NavigationUrls.SELLER_LIST_BY_ACCEPTING_JOB) ||
                            this.props.history.location.pathname.startsWith(NavigationUrls.SELLER_CATEGORY_RADIUS) ||
                            this.props.history.location.pathname.startsWith(NavigationUrls.SET_SELLER_PWD) ||
                            this.props.history.location.pathname.startsWith(NavigationUrls.SAAS_METRICS) ?
                            
                            <div key="top-panel" className="master-top-panel" ref={this.pageTopRef}>
                                <div className="content-panel">
                                    <div className="top-bar-new">
                                        <Menu className="master-menu">
                                            <Menu.Item header className="header-logo">
                                                <a href="/"><img src="https://com-syndafy-dealgrace-static.s3.us-east-2.amazonaws.com/dealgrace-marketplace-white_1gmhg63kktxlce29_.svg" className="logo" /></a>
                                            </Menu.Item>
                                            {
                                                this.props.showSearchFormInHeader == true && this.state.windowWidth >= 768 &&
                                                <Menu.Item className="search-container"></Menu.Item>
                                            }
                                            <Menu.Menu position='right' className="top-bar-links">
                                                {!this.props.loggedIn && this.state.windowWidth >= 768 &&
                                                    <Menu.Item>
                                                        <Button className="button-primary" href="/signin">Login</Button>
                                                    </Menu.Item>
                                                }
                                                {!this.props.loggedIn && this.state.windowWidth < 1024 &&
                                                    <Menu.Item>
                                                        <Dropdown className="responsive-menu" trigger={<img src={hamburger_icon} />}>
                                                            <Dropdown.Menu>
                                                                {this.state.windowWidth < 768 &&
                                                                    <Dropdown.Item key='menu_login'>
                                                                        <Button className="button-primary" href="/signin">Login</Button>
                                                                    </Dropdown.Item>
                                                                }
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </Menu.Item>
                                                }
                                                {this.props.loggedIn &&
                                                    <Menu.Item>
                                                        <Dropdown className="loggedin-user" text={`${currentUser.firstName.charAt(0)}`} >
                                                            <Dropdown.Menu>
                                                                <div className="balloon">
                                                                    <div>
                                                                        <div>{`${currentUser.firstName.charAt(0)}`}</div>
                                                                    </div>
                                                                    <div className={"user-name"}>
                                                                        <p>
                                                                            {`${currentUser.firstName} ${currentUser.lastName}`}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <Dropdown.Item key="service-request" text="Service Requests" onClick={() => {
                                                                    this.props.history.history('/',
                                                                        { state: { visitTime: moment().unix() } }
                                                                    );
                                                                }} icon="search" />

                                                                {checkManagerAuthorization(featuresList.BUSINESS_PROFILE, this.props.currentUser) ?
                                                                    <Dropdown.Item key="seller-profile" text="Business Profile" onClick={() => {
                                                                        this.props.history.history(
                                                                            '/seller-profile',
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="user" /> : ""}

                                                                {checkManagerAuthorization(featuresList.BUSINESS_REVIEWS, this.props.currentUser) ?
                                                                    <Dropdown.Item key="seller-reviews" text="Business Reviews" onClick={() => {
                                                                        this.props.history.history(
                                                                            '/seller-reviews',
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="user" /> : ""}
                                                                {checkManagerAuthorization(featuresList.MESSENGER, this.props.currentUser) ?
                                                                    <Dropdown.Item key="messenger" text="Messenger" onClick={() => {
                                                                        this.props.history.history(
                                                                            '/messenger',
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="user" />
                                                                    : ""}
                                                                {checkManagerAuthorization(featuresList.RADIUS_CHECK, this.props.currentUser) ?
                                                                    <Dropdown.Item key="radius-check" text="Radius Check" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.RADIUS_CHECK,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="search" />
                                                                    : ""}
                                                                {checkManagerAuthorization(featuresList.SUBSCRIPTIONS_SEARCH, this.props.currentUser) ?
                                                                    <Dropdown.Item key="subscription-search" text="Subscriptions" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.SUBSCRIPTION_SEARCH,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );
                                                                    }} icon="user" /> : ""}

                                                                {checkManagerAuthorization(featuresList.TRIAL_SUBSCRIPTIONS, this.props.currentUser) ?
                                                                    <Dropdown.Item key="trial-subscription" text="Trial Subscription" onClick={() => {
                                                                        this.props.history.history(
                                                                            '/trial-subscription',
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="user" /> : ""}

                                                            {checkManagerAuthorization(featuresList.SAAS_METRICS, this.props.currentUser) ?
                                                                <Dropdown.Item key="saas-metrics" text="SAAS Metrics" onClick={() => {
                                                                    this.props.history.history(
                                                                        NavigationUrls.SAAS_METRICS,
                                                                        { state: { visitTime: moment().unix() } }
                                                                    );

                                                                }} icon="chart bar" /> : ""}
                                                                {checkManagerAuthorization(featuresList.FAILED_COMMISSION_PAYMENTS, this.props.currentUser) ?
                                                                    <Dropdown.Item key="failed-commission-payments" text="Failed Commission Payments" onClick={() => {
                                                                        this.props.history.history(
                                                                            '/failed-commission-payments',
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="user" /> : ""}

                                                                {checkManagerAuthorization(featuresList.FAILED_SUBSCRIPTION_PAYMENTS, this.props.currentUser) ?
                                                                    <Dropdown.Item key="failed-subscription-payments" text="Failed Subscription Payments" onClick={() => {
                                                                        this.props.history.history(
                                                                            '/failed-subscription-payments',
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="user" /> : ""}

                                                                    {checkManagerAuthorization(featuresList.COMMISSION_PAYMENTS, this.props.currentUser) ?
                                                                        <Dropdown.Item key="commission-payment" text="Commission Payments" onClick={() => {
                                                                            this.props.history.history(
                                                                                NavigationUrls.COMMISSION_PAYMENTS,
                                                                                { state: { visitTime: moment().unix() } }
                                                                            );

                                                                        }} icon="user" /> : ""}

                                                                {checkManagerAuthorization(featuresList.ACCOUNTS_DASHBOARD, this.props.currentUser) ?
                                                                    <Dropdown.Item key="accounts-dashboard" text="Accounts Dashboard" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.ACCOUNTS_DASHBOARD,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="chart area" /> : ""}

                                                                {checkManagerAuthorization(featuresList.ADD_SELLER_SUBSCRIPTION, this.props.currentUser) ?
                                                                    <Dropdown.Item text="Add Seller Subscription" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.ADD_SUBSCRIPTION,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="user" /> : ""}

                                                                {checkManagerAuthorization(featuresList.ADD_SELLER_SUBSCRIPTION, this.props.currentUser) ?
                                                                    <Dropdown.Item text="Add Commission Only Subscription" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.ADD_COMMISSION_ONLY_SUBSCRIPTION,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="user" /> : ""}

                                                                {checkManagerAuthorization(featuresList.REQUEST_DASHBOARD, this.props.currentUser) ?
                                                                    <Dropdown.Item text="Request Dashboard" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.REQUEST_DASHBOARD,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="dashboard" /> : ""}

                                                                {
                                                                    <Dropdown.Item text="AM Dashboard" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.AM_DASHBOARD,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="dashboard" /> 
                                                                }

                                                                {checkManagerAuthorization(featuresList.FILL_RATE, this.props.currentUser) ?
                                                                    <Dropdown.Item text="Fill Rate" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.USERS_FILLRATE_DASHBOARD,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="user" /> : ""}

                                                                {checkManagerAuthorization(featuresList.WEEKLY_FILL_RATE, this.props.currentUser) ?
                                                                    <Dropdown.Item text="Weekly Fill Rate" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.USERS_WEEKLY_FILLRATE,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="chart area" /> : ""}
                                                                {checkManagerAuthorization(featuresList.CHURN_CANDIDATES, this.props.currentUser) ?
                                                                    <Dropdown.Item text="Churn Candidates" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.CHURN_CANDIDATES,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="users" /> : ""}
                                                                {checkManagerAuthorization(featuresList.SHOW_PAYMENT_PLANS, this.props.currentUser) ?
                                                                    <Dropdown.Item text="Payment Plans" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.PAYMENT_PLANS,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="money bill alternate outline" /> : ""}
                                                                {(checkManagerAuthorization(featuresList.IMPERSONATE_BUYER, this.props.currentUser) || checkManagerAuthorization(featuresList.IMPERSONATE_SELLER, this.props.currentUser)) ?
                                                                    <Dropdown.Item text="Impersonate User" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.IMPERSONATE_USER,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="user secret" /> : ""}
                                                                {(checkManagerAuthorization(featuresList.ACTUAL_COMMISSION_REVENUE, this.props.currentUser)) ?
                                                                    <Dropdown.Item text="Daily Lead Fee Revenue" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.ACTUAL_COMMISSION_REVENUE,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="chart area" /> : ""}
                                                                {(checkManagerAuthorization(featuresList.SET_SELLER_PWD, this.props.currentUser)) ?
                                                                <Dropdown.Item text="Set Seller Password" onClick={() => {
                                                                    this.props.history.history(
                                                                        NavigationUrls.SET_SELLER_PWD,
                                                                        { state: { visitTime: moment().unix() } }
                                                                    );

                                                                }} icon="key" /> : ""}
                                                                    {(checkManagerAuthorization(featuresList.SELLER_LIST_BY_ACCEPTING_JOB, this.props.currentUser)) ?
                                                                    <Dropdown.Item text="Accepting Jobs" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.SELLER_LIST_BY_ACCEPTING_JOB,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="dashboard" /> : ""}

                                                                    {(checkManagerAuthorization(featuresList.SELLER_CATEGORY_RADIUS, this.props.currentUser)) ?
                                                                    <Dropdown.Item text="Seller Category Radius" onClick={() => {
                                                                        this.props.history.history(
                                                                            NavigationUrls.SELLER_CATEGORY_RADIUS,
                                                                            { state: { visitTime: moment().unix() } }
                                                                        );

                                                                    }} icon="circle outline" /> : ""}
                                                                <Dropdown.Item text="Sign Out" icon="sign-out" onClick={logout} />
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </Menu.Item>
                                                }
                                            </Menu.Menu>
                                        </Menu>
                                    </div>
                                </div>
                            </div> : ""
                        }
                        <div className="master-content-pane">
                            <Routes>
                                <Route exact path="/signin" element={<SignInContainerNew />} />
                                <Route exact path='/' element={<PrivateRoute component={ServiceRequestListContainerNew} />} />
                                <Route exact path='/request/:requestID' element={<PrivateRoute component={ServiceRequestListContainerNew} />} />
                                {checkManagerAuthorization(featuresList.BUSINESS_PROFILE, this.props.currentUser) ?
                                    <Route exact path='/seller-profile' element={<PrivateRoute component={UpdateSellerContainer} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.BUSINESS_REVIEWS, this.props.currentUser) ?
                                    <Route exact path='/seller-reviews' element={<PrivateRoute component={SellerReviewContainer} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.TRIAL_SUBSCRIPTIONS, this.props.currentUser) ?
                                    <Route exact path='/trial-subscription' element={<PrivateRoute component={TrialSubscriptions} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.ADD_SELLER_SUBSCRIPTION, this.props.currentUser) ?
                                    <Route exact path={NavigationUrls.ADD_SUBSCRIPTION} element={<PrivateRoute component={AddSubscription} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.ADD_SELLER_SUBSCRIPTION, this.props.currentUser) ?
                                    <Route exact path={NavigationUrls.ADD_COMMISSION_ONLY_SUBSCRIPTION} element={<PrivateRoute component={AddCommissionOnlySubscription} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.SAAS_METRICS, this.props.currentUser) ?
                                    <Route exact path={NavigationUrls.SAAS_METRICS} element={<PrivateRoute component={SaasMetricsContainer} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.FAILED_COMMISSION_PAYMENTS, this.props.currentUser) ?
                                    <Route exact path="/failed-commission-payments" element={<PrivateRoute component={FailedCommissionPayments} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.ACCOUNTS_DASHBOARD, this.props.currentUser) ?
                                    <Route exact path="/accounts-dashboard" element={<PrivateRoute component={AccountsDashboardContainer} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.MESSENGER, this.props.currentUser) ?
                                    <Route exact path="/messenger" element={<PrivateRoute component={MessengerContainer} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.MESSENGER, this.props.currentUser) ?
                                    <Route exact path="/messenger" element={<PrivateRoute component={MessengerContainer} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.FAILED_SUBSCRIPTION_PAYMENTS, this.props.currentUser) ?
                                    <Route exact path="/failed-subscription-payments" element={<PrivateRoute component={FailedSubscriptionsContainer} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.SUBSCRIPTIONS_SEARCH, this.props.currentUser) ?
                                    <Route exact path={NavigationUrls.SUBSCRIPTION_SEARCH} element={<PrivateRoute component={SubscriptionSearchContainer} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.SUBSCRIPTIONS_SEARCH, this.props.currentUser) ?
                                    <Route exact path={NavigationUrls.SUBSCRIPTION_SEARCH_WITH_ID} element={<PrivateRoute component={SubscriptionSearchContainer} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.REQUEST_DASHBOARD, this.props.currentUser) ?
                                    <Route exact path="/request-dashboard" element={<PrivateRoute component={SBRAssignmentDashboardContainer} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.FILL_RATE, this.props.currentUser) ?
                                    <Route exact path="/users-fill-rate" element={<PrivateRoute component={UsersFillRateDashboardContainer} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.WEEKLY_FILL_RATE, this.props.currentUser) ?
                                    <Route exact path={NavigationUrls.USERS_WEEKLY_FILLRATE} element={<PrivateRoute component={UsersWeeklyFillRateContainer} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.CHURN_CANDIDATES, this.props.currentUser) ?
                                    <Route exact path={NavigationUrls.CHURN_CANDIDATES} element={<PrivateRoute component={ChurnCandidatesContainer} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.COMMISSION_PAYMENTS, this.props.currentUser) ?
                                    <Route exact path={NavigationUrls.COMMISSION_PAYMENTS} element={<PrivateRoute component={CommissionPayments} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.SHOW_PAYMENT_PLANS, this.props.currentUser) ?
                                    <Route exact path={NavigationUrls.PAYMENT_PLANS} element={<PrivateRoute component={SellerPlans} />} />
                                    : <></>
                                }
                                {(checkManagerAuthorization(featuresList.IMPERSONATE_BUYER, this.props.currentUser) || checkManagerAuthorization(featuresList.IMPERSONATE_SELLER, this.props.currentUser)) ?
                                    <Route exact path={NavigationUrls.IMPERSONATE_USER} element={<PrivateRoute component={ImpersonateUsers} />} />
                                    : <></>
                                }
                                {checkManagerAuthorization(featuresList.RADIUS_CHECK, this.props.currentUser) ?
                                    <Route exact path={NavigationUrls.RADIUS_CHECK} element={<PrivateRoute component={RadiusCheckContainer} />} />
                                    : <></>
                                }
                                {(checkManagerAuthorization(featuresList.ACTUAL_COMMISSION_REVENUE, this.props.currentUser)) ?
                                    <Route exact path={NavigationUrls.ACTUAL_COMMISSION_REVENUE} element={<PrivateRoute component={ActualCommissionRevenue} />} />
                                    : <></>
                                }
                                {(checkManagerAuthorization(featuresList.SET_SELLER_PWD, this.props.currentUser)) ?
                                    <Route exact path={NavigationUrls.SET_SELLER_PWD} element={<PrivateRoute component={SetSellerPasswordContainer} />} />
                                    : <></>
                                }
                                {(checkManagerAuthorization(featuresList.SELLER_LIST_BY_ACCEPTING_JOB, this.props.currentUser)) ?
                                    <Route exact path={NavigationUrls.SELLER_LIST_BY_ACCEPTING_JOB} element={<PrivateRoute component={SellerListByAcceptingJob} />} />
                                    : <></>
                                }

                                {(checkManagerAuthorization(featuresList.SELLER_CATEGORY_RADIUS, this.props.currentUser)) ?
                                    <Route exact path={NavigationUrls.SELLER_CATEGORY_RADIUS} element={<PrivateRoute component={SellerCategoryRadiusContainer} />} />
                                    : <></>
                                }

                                <Route exact path={NavigationUrls.AM_DASHBOARD} element={<PrivateRoute component={AMDashboardContainer} />} />


                            </Routes>
                        </div>
                        <div className="main-page-panel footer"></div>
                    </div>
                </Container>
                <NotificationContainer />
            </>
        )
    }
}

function mapStateToProps({ auth, reducer, appView, locationDetails, searchForm }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component

    return {
        loggedIn: auth.loggedIn,
        currentUser: auth.currentUser,
        loginError: auth.loginError,
        homeScreenLoading: reducer.homeScreenLoading,
        showSidebar: appView.showSidebar,
        locationEnabled: locationDetails.locationEnabled,
        lat: locationDetails.lat,
        lon: locationDetails.lon,
        showSearchFormInHeader: searchForm.showSearchBarInHeader,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setAuthState,
        setSearchFormVisibilityInHeader,
        setPageType,
        setShowSidebar
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(MasterContainer);

